/**
 *
 * 日期格式化工具类
 *
 *
 * */

class DateUtil {

  static DEFAULT_FORMAT = 'yyyy-MM-dd hh:mm:ss'


  static parse(date) {
    return new Date(date);
  }
  
  /**
   * 日期数字大小写转换
   * @param {*} v 
   * @param {*} type 'lowercase'：大写转小写 uppercase'：小写转大写
   * @returns 转换后的日期
   */
  parseDate(v ,type) {
    let replaceNum = null
    let r = '';
    let result = null
    let year = null
    let month = null
    let date = null
    if(type === 'lowercase') {
        replaceNum = num => {
            num = num.replace(/二十/g, "2");
            num = num.replace(/十/g, "1");
            num = num.replace(/〇/g, "0");
            num = num.replace(/一/g, "1");
            num = num.replace(/二/g, "2");
            num = num.replace(/三/g, "3");
            num = num.replace(/四/g, "4");
            num = num.replace(/五/g, "5");
            num = num.replace(/六/g, "6");
            num = num.replace(/七/g, "7");
            num = num.replace(/八/g, "8");
            num = num.replace(/九/g, "9");
            return num;
        };
        r = /年|月|日/;
        result = v.split(r);
        year = replaceNum(result[0]);
        month = replaceNum(result[1])
        month = month > 10 ? month : '0' + month
        date = replaceNum(result[2])
        date = date > 10 ? date : '0' + date
        return `${year}-${month}-${date}`;
      } else if (type === 'uppercase') {
          replaceNum = num => {
              num = num.replace(/0/g, "〇");
              num = num.replace(/1/g, "一");
              num = num.replace(/2/g, "二");
              num = num.replace(/3/g, "三");
              num = num.replace(/4/g, "四");
              num = num.replace(/5/g, "五");
              num = num.replace(/6/g, "六");
              num = num.replace(/7/g, "七");
              num = num.replace(/8/g, "八");
              num = num.replace(/9/g, "九");
              return num;
          };
          r = /(\d{4})-(\d{2})-(\d{2})/;
          result = v.match(r);
          year = replaceNum(result[1]);
          month = replaceNum(result[2]).replace(
              /一([一二三四五六七八九])/,
              "十$1"
          ).replace(
              /一〇/,
              "十"
          ).replace(
              /〇([一二三四五六七八九〇])/,
              "$1"
          )
          date = replaceNum(result[3]).replace(
              /一([一二三四五六七八九])/,
              "十$1"
          ).replace(
              /二([一二三四五六七八九])/,
              "二十$1"
          ).replace(
              /三([一二三四五六七八九])/,
              "三十$1"
          ).replace(
              /一〇/,
              "十"
          ).replace(
              /二〇/,
              "二十"
          ).replace(
              /三〇/,
              "三十"
          ).replace(
              /〇([一二三四五六七八九〇])/,
              "$1"
          )
          return `${year}年${month}月${date}日`;
      }
  }
  
  format(date, fmt) {
    if (!fmt) {
      fmt = DateUtil.DEFAULT_FORMAT;
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(), //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      "S": date.getMilliseconds() //毫秒
    };

    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + '';
        let time = ('00' + str).substr(str.length);
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : time);
      }
    }
    return fmt;
  }

  /** 
   * 计算停留的天数
    * @param {object} data 信息对象 
    * @param {string} departureDate 离境日期
    * @param {string} entryDate 入境日期
    * @return {dates} 具体天数
  */
  outsideNum(data,entryDate,depaDate){
    if(data instanceof Object && entryDate && depaDate){
        let startTime = new Date(
          Date.parse(entryDate.replace(/-/g, "/"))
        ).getTime();
        let endTime = new Date(
            Date.parse(depaDate.replace(/-/g, "/"))
          ).getTime();
        let date = (endTime - startTime) / (1000 * 60 * 60 * 24) + 1;
        let dates;
        if(date === 0){
          dates = 1
        }else{
          dates = date;
        }
        return Number(dates);
      }
  }
  /**
   *  计算入境日期
   *  @param {number} num 停留天数
   *  @param {string} depDate 离境日期
   * 
   */
  getPreDepaDate(num,depaDate){
    let preDepaDate;
    let endTime = new Date(
        Date.parse(depaDate.replace(/-/g, "/"))
      ).getTime();
    let sNum = num - 1;
    let nums = sNum  * (1000 * 60 * 60 * 24 - 1);
    let startTime = endTime - nums;
    let today;
    if( new Date(startTime).getDate() < 10){//如果天数小于10，则给日期前+0,否的话则不用加
          today = `0${new Date(startTime).getDate()}`
    }else{
        today = new Date(startTime).getDate();
    }
    preDepaDate = `${new Date(startTime).getFullYear()}-${("0" + (new Date(startTime).getMonth() + 1)).slice(-2)}-${today}`;
    return preDepaDate
  }
  /**
   * 计算离境日期
   * @param {object} data 信息对象
   * @param {number} v 最新数据
   * @param {string} entryDate 开始日期
   * @return {string} 计算出来的日期
   */
  getDepartureDate(data,v,entryDate){
    if (!entryDate) {
      return '';
    }
    if(entryDate && entryDate.length >10){
      entryDate = entryDate.slice(0,10)
    }
    if(data instanceof Object && entryDate){
      let startTime = new Date(
        Date.parse(entryDate.replace(/-/g, "/"))
      ).getTime();
      let endTime =  v * (1000 * 60 * 60 * 24 - 1) + startTime;
      let today;
      if( new Date(endTime).getDate() < 10){//如果天数小于10，则给日期前+0,否的话则不用加
            today = `0${new Date(endTime).getDate()}`
      }else{
          today = new Date(endTime).getDate();
      }
      let date = `${new Date(endTime).getFullYear()}-${("0" + (new Date(endTime).getMonth() + 1)).slice(-2)}-${today}`;
      return date;
    }
  }

  /**
   *
   *
   * @param {*} outsideNum 停留天数
   * @param {*} preDepaDate 入境日期
   * @returns
   * @memberof DateUtil
   */
  backDate(outsideNum,preDepaDate) {
    let date = this.getDepartureDate({},outsideNum,preDepaDate);
    return date;
  }

  //往前推N个月
  lowMonth(dateVal, num) {
    if (parseInt(num) > 0) {//m是 往前推的总月份
      let myDate = new Date();
      let yearNum = parseInt(dateVal.split('-')[0])
      let monthNum = parseInt(dateVal.split('-')[1].replace(/\b(0+)/gi, "")) //获取当前月
      let dayNum = parseInt(dateVal.split('-')[2].replace(/\b(0+)/gi, ""))
      let year = yearNum; //获取当前年
      let month = monthNum;//获取当前月
      let day = dayNum < 10 ? ('0' + dayNum) : dayNum
      let lowData = '';//当前年月日往前推m个月后获取到的年月日
      let ylow = parseInt(parseInt(num) / 12);//往前推的总月份换成对应的年数取整
      let mlow = parseInt(num) % 12;//往前推的月数
      if (ylow > 0) {
        year -= ylow;//年要再减一
      } else {
        year = year;//年取当前年份
      }
      if ((mlow > month) || (mlow == month)) {//往前推的月份大于或等于当前月份，12减去往前推的月份加上现在的月份
        year = year - 1;
        month = (12 - mlow + month) < 10 ? ('0' + (12 - mlow + month)) : (12 - mlow + month);
        lowData = year + '-' + month + '-' + day
      } else {//往前推的月份小于当前月份
        month = mlow < 10 ? ('0' + mlow) : mlow;
        lowData = year + '-' + month + '-' + day
      }
      return lowData
    } else {
      // console.log(num)
    }
  }


  /**
   * 返回指定长度的月份集合
   *
   * @param {time} 时间
   * @param {len} 长度
   * @param {direction} 方向： 1: 前几个月; 2: 后几个月; 3:前后几个月 默认 3
   * @return {Array} 数组
   *
   * @example  getMonths('2018-1-29', 6, 1) // -> ["2018-1", "2017-12", "2017-11", "2017-10", "2017-9", "2017-8", "2017-7"]
   */
  static getMonths(time, len, direction) {
    var mm = new Date(time).getMonth(),
      yy = new Date(time).getFullYear(),
      direction = isNaN(direction) ? 3 : direction,
      index = mm;
    var cutMonth = function (index) {
      if (index <= len && index >= -len) {
        return direction === 1 ? formatPre(index).concat(cutMonth(++index)) :
          direction === 2 ? formatNext(index).concat(cutMonth(++index)) : formatCurr(index).concat(cutMonth(++index))
      }
      return []
    }
    var formatNext = function (i) {
      var y = Math.floor(i / 12),
        m = i % 12
      return [yy + y + '-' + (m + 1)]
    }
    var formatPre = function (i) {
      var y = Math.ceil(i / 12),
        m = i % 12
      m = m === 0 ? 12 : m
      return [yy - y + '-' + (13 - m)]
    }
    var formatCurr = function (i) {
      var y = Math.floor(i / 12),
        yNext = Math.ceil(i / 12),
        m = i % 12,
        mNext = m === 0 ? 12 : m
      return [yy - yNext + '-' + (13 - mNext), yy + y + '-' + (m + 1)]
    }
    // 数组去重
    var unique = function (arr) {
      if (Array.hasOwnProperty('from')) {
        return Array.from(new Set(arr));
      } else {
        var n = {}, r = [];
        for (var i = 0; i < arr.length; i++) {
          if (!n[arr[i]]) {
            n[arr[i]] = true;
            r.push(arr[i]);
          }
        }
        return r;
      }
    }
    return direction !== 3 ? cutMonth(index) : unique(cutMonth(index).sort(function (t1, t2) {
      return new Date(t1).getTime() - new Date(t2).getTime()
    }))
  }

  /**
   * 返回指定长度的天数集合
   *
   * @param {time} 时间
   * @param {len} 长度
   * @param {direction} 方向： 1: 前几天; 2: 后几天; 3:前后几天 默认 3
   * @return {Array} 数组
   *
   * @example date.getDays('2018-1-29', 6) // -> ["2018-1-26", "2018-1-27", "2018-1-28", "2018-1-29", "2018-1-30", "2018-1-31", "2018-2-1"]
   */
  static getDays(time, len, diretion) {
    var tt = new Date(time)
    var getDay = function (day) {
      var t = new Date(time)
      t.setDate(t.getDate() + day)
      var m = t.getMonth() + 1
      return t.getFullYear() + '-' + m + '-' + t.getDate()
    }
    var arr = []
    if (diretion === 1) {
      for (var i = 1; i <= len; i++) {
        arr.unshift(getDay(-i))
      }
    } else if (diretion === 2) {
      for (var i = 1; i <= len; i++) {
        arr.push(getDay(i))
      }
    } else {
      for (var i = 1; i <= len; i++) {
        arr.unshift(getDay(-i))
      }
      arr.push(tt.getFullYear() + '-' + (tt.getMonth() + 1) + '-' + tt.getDate())
      for (var i = 1; i <= len; i++) {
        arr.push(getDay(i))
      }
    }
    return diretion === 1 ? arr.concat([tt.getFullYear() + '-' + (tt.getMonth() + 1) + '-' + tt.getDate()]) :
      diretion === 2 ? [tt.getFullYear() + '-' + (tt.getMonth() + 1) + '-' + tt.getDate()].concat(arr) : arr
  }


  /*获取某月有多少天*/
  static getMonthOfDay(time) {
    var date = new Date(time)
    var year = date.getFullYear()
    var mouth = date.getMonth() + 1
    var days

    //当月份为二月时，根据闰年还是非闰年判断天数
    if (mouth == 2) {
      days = year % 4 == 0 ? 29 : 28
    } else if (mouth == 1 || mouth == 3 || mouth == 5 || mouth == 7 || mouth == 8 || mouth == 10 || mouth == 12) {
      //月份为：1,3,5,7,8,10,12 时，为大月.则天数为31；
      days = 31
    } else {
      //其他月份，天数为：30.
      days = 30
    }
    return days
  }

  /*获取某年有多少天*/
  static getYearOfDay(time) {
    var firstDayYear = this.getFirstDayOfYear(time);
    var lastDayYear = this.getLastDayOfYear(time);
    var numSecond = (new Date(lastDayYear).getTime() - new Date(firstDayYear).getTime()) / 1000;
    return Math.ceil(numSecond / (24 * 3600));
  }

  /*获取某年的第一天*/
  static getFirstDayOfYear(time) {
    var year = new Date(time).getFullYear();
    return year + "-01-01 00:00:00";
  }

  /*获取某年最后一天*/
  static getLastDayOfYear(time) {
    var year = new Date(time).getFullYear();
    var dateString = year + "-12-01 00:00:00";
    var endDay = this.getMonthOfDay(dateString);
    return year + "-12-" + endDay + " 23:59:59";
  }

  /*获取某个日期是当年中的第几天*/
  static getDayOfYear(time) {
    var firstDayYear = this.getFirstDayOfYear(time);
    var numSecond = (new Date(time).getTime() - new Date(firstDayYear).getTime()) / 1000;
    return Math.ceil(numSecond / (24 * 3600));
  }

  /*获取某个日期在这一年的第几周*/
  static getDayOfYearWeek(time) {
    var numdays = this.getDayOfYear(time);
    return Math.ceil(numdays / 7);
  }

  static calcDate(date1, date2) {
    var date3 = date2 - date1;

    var days = Math.floor(date3 / (24 * 3600 * 1000))

    var leave1 = date3 % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))

    var leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))

    var leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
    var seconds = Math.round(date3 / 1000)
    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds,
    }
  }


}

export default DateUtil
